import { NavLink } from 'react-router-dom';
import { PropsWithChildren } from 'react';
import { isExternalUrl } from '@synergy/utils';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    default: {
        textDecoration: 'none',
    },
    product: {
        color: '#21272E',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    external: {
        color: 'inherit',
    },
}));

interface NavigationLinkProps {
    url: string;
    target?: '_self' | '_blank' | '_parent' | '_top';
    productLink?: boolean;
    onClick?: () => void;
    className?: string;
    isExternal?: boolean;
}

export const NavigationLink = (props: PropsWithChildren<NavigationLinkProps>) => {
    const classes = useStyles();

    const { productLink, url, target, onClick, children, isExternal } = props;
    const style = `${props.className ?? ''} ${classes.default} ${productLink && classes.product}`;
    const externalStyle = `${style} ${isExternal && classes.external}`;

    if (isExternal || isExternalUrl(url)) {
        return (
            <a href={url} target={target || '_blank'} className={externalStyle} onClick={onClick}>
                {children}
            </a>
        );
    } else {
        return (
            <NavLink className={style} to={url} onClick={onClick}>
                {children}
            </NavLink>
        );
    }
};
